import da from './da';
import de from './de';
import enUS from './en-US';
import esCO from './es-CO';
import fr from './fr-FR';
import itIt from './it-IT';
import nlNL from './nl-NL';
import noNO from './no-NO';
import plPL from './pl-PL';
import svSE from './sv-SE';
import pt from './pt';
import roRO from './ro-RO';
import bgBG from './bg-BG';
import hrHR from './hr-HR';
import ltLT from './lt-LT';
import etEE from './et-EE';

export default {
  da,
  de,
  'en-US': enUS,
  'en-GB': enUS,
  'es-CO': esCO,
  'fr-FR': fr,
  'it-IT': itIt,
  'nl-NL': nlNL,
  'no-NO': noNO,
  'pl-PL': plPL,
  'sv-SE': svSE,
  pt,
  'ro-RO': roRO,
  'bg-BG': bgBG,
  'hr-HR': hrHR,
  'lt-LT': ltLT,
  'et-EE': etEE,
};
